<template>
  <div class="kd-form__text-input" :class="[classes]">
    <slot></slot>

    <span class="kd-count" v-if="enableCounter">{{ inputLength }} / {{ counterLength }}</span>

  </div>
</template>

<script>
  import isArray from '../../../utils/is-array';

  export default {
    name: 'kd-input-container',
    props: {
      inline: Boolean,
      has_password: Boolean
    },
    data() {
      return {
        value: '',
        input: false,
        inputInstance: null,
        showPassword: false,
        enableCounter: false,
        hasSelect: false,
        hasPlaceholder: false,
        isDisabled: false,
        isRequired: false,
        isFocused: false,
        counterLength: 0,
        inputLength: 0
      };
    },
    computed: {
      hasValue() {
        if (isArray(this.value)) {
          return this.value.length > 0;
        }

        return Boolean(this.value);
      },
      classes() {
        return {
          // 'kd-input-inline': this.inline,
          // 'kd-has-password': this.has_password,
          // 'kd-has-select': this.hasSelect,
          'has-value': this.hasValue,
          'has-placeholder': this.hasPlaceholder,
          // 'kd-input-disabled': this.isDisabled,
          // 'kd-input-required': this.isRequired,
          'has-focus': this.isFocused
        };
      }
    },
    methods: {
      isInput() {
        return this.input && this.input.tagName.toLowerCase() === 'input';
      },
      togglePasswordType() {
        if (this.isInput()) {
          if (this.input.type === 'password') {
            this.input.type = 'text';
            this.showPassword = true;
          } else {
            this.input.type = 'password';
            this.showPassword = false;
          }

          this.input.focus();
        }
      },
      setValue(value) {
        this.value = value;
      }
    },
    mounted() {
      this.input = this.$el.querySelectorAll('input, textarea, select')[0];

      if (!this.input) {
        this.$destroy();

        throw new Error('Missing input/select/textarea inside kd-input-container');
      }
    }
  };
</script>
